module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAALVBMVEUAAABRZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1RZr1N4toXAAAADnRSTlMA80Uo3MeaAUDw2L+iKaySY94AAABlSURBVAjXY2Bg4EgRdFNgAALmfe/evXttAGQ1vgMBCaDQPDDrpQFD6TsICGfQg7IeMeRBWc8Y/KCsJwxyUNZDOOsdwzq47Dko6w3CFITJcNsuILmAgTkOyHhqAHJgUcrDZeoMDAD4wHDV39MXagAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paySystem/button_round.png
// module id = CnXM
// module chunks = 1